<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-daterange>
            <kendo-dateinput
                kendoDateRangeStartInput
                [ngClass]="generateInputStyle()"
                [disabled]="isDisabled"
                [isRequired]="isRequired"
                [format]="format || defaultDateFormat"
                [formatPlaceholder]="formatPlaceholder"
                [ngModel]="dateValue()?.startDate"
                (valueChange)="onValueChange({ startDate: $event, endDate: dateValue()?.endDate })"
                (focusin)="onFocusIn()"
                (focusout)="onFocusOut()" />
            <kendo-dateinput
                kendoDateRangeEndInput
                [ngClass]="generateInputStyle()"
                [isRequired]="isRequired"
                [disabled]="isDisabled"
                [format]="format || defaultDateFormat"
                [formatPlaceholder]="formatPlaceholder"
                [ngModel]="dateValue()?.endDate"
                (valueChange)="onValueChange({ startDate: dateValue()?.startDate, endDate: $event })"
                (focusin)="onFocusIn()"
                (focusout)="onFocusOut()" />
        </kendo-daterange>
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span kendoTooltip [title]="(value()?.startDate | customDate) + ' - ' + (value()?.endDate | customDate)">
                {{ value()?.startDate | customDate }} - {{ value()?.endDate | customDate }}
            </span>
        </div>
    }
</app-input-label>
